import { generatePath } from 'react-router-dom'
import { PAID_ADS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { CurrencyDollar } from 'blaze-ui/icons'
import { WithAutopilotUpgradeBadge } from 'components/AutopilotUpgradeButtons/WithAutopilotUpgradeBadge'
import { Pill } from 'components/Pill/Pill'
import Styles from '../NavMenu.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { PaidAds } from 'blaze-ui/icons/24'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { DesktopBadge } from '../DesktopBadge/DesktopBadge'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuPaidAdsItem = ({ workspaceId, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isMobile = useResponsiveDesign()

  return (
    <NavMenuItem
      icon={isSystemRedesignEnabled ? PaidAds : CurrencyDollar}
      activeIcon={isSystemRedesignEnabled ? PaidAds : CurrencyDollar}
      to={generatePath(PAID_ADS_PATH, { workspaceId })}
      onPress={onPress}
      label={'Meta Ads'}
    >
      {(isActive) => (isMobile ? <DesktopBadge /> : <UpgradeBadge isActive={isActive} />)}
    </NavMenuItem>
  )
}

const UpgradeBadge = ({ isActive }: { isActive: boolean }) => {
  return (
    <WithAutopilotUpgradeBadge color={isActive ? '#9500FF' : 'var(--dark-15)'}>
      {({ isRenderingBadge }) => (
        <>
          {isRenderingBadge ? null : (
            <Pill className={Styles.betaPill} size="sm">
              Beta
            </Pill>
          )}
        </>
      )}
    </WithAutopilotUpgradeBadge>
  )
}

export { NavMenuPaidAdsItem }
